module.exports = __webpack_public_path__ + "static/img/noticia8.a229f22a.jpg";